import * as yup from 'yup';
import i18next from 'i18next';

export const validation = (maxRefundAmount, paymentType) => {
  const shape = {
    refundAmount: yup
      .string()
      .test('required', i18next.t('validation.report.refundAmountRequired'), (value) => {
        return value !== undefined && value !== null && value !== '' && value.trim() !== '';
      })
      .test('is-number', i18next.t('validation.report.refundAmountValid'), (value) => {
        if (!value || value.trim() === '') return false;
        const num = parseFloat(value);
        return !isNaN(num);
      })
      .test('is-positive', i18next.t('validation.report.refundAmountGreaterThanZero'), (value) => {
        if (!value || value.trim() === '') return false;
        const num = parseFloat(value);
        return !isNaN(num) && num > 0;
      })
      .test('not-exceed-customer-paid', i18next.t('validation.report.refundAmountExceedsCustomerPaid'), (value) => {
        if (!value || value.trim() === '') return true; 
        if (!maxRefundAmount) return true;
        const refundAmount = parseFloat(value);
        const maxRefund = parseFloat(maxRefundAmount);
        if (isNaN(refundAmount) || isNaN(maxRefund)) return true;
        return refundAmount <= maxRefund;
      }),
    paymentType: yup.string().nullable(),
    bankName: yup
      .string()
      .trim()
      .nullable()
      .when('paymentType', {
        is: (paymentType) => paymentType === 'check' || paymentType === 'finance',
        then: (schema) => schema.required(i18next.t('validation.report.bankNameRequired')),
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
    checkNumber: yup
      .string()
      .trim()
      .nullable()
      .when('paymentType', {
        is: (paymentType) => paymentType === 'check' || paymentType === 'finance',
        then: (schema) => schema
          .required(i18next.t('validation.report.checkNumberRequired'))
          .test('no-special-chars', i18next.t('validation.report.specialCharacterNotAllowed'), (value) => {
            if (!value || value.trim() === '') return false; 
            return /^[A-Za-z0-9]+$/.test(value.trim());
          })
          .test('min-length-finance', (value, context) => {
            if (!value || value.trim() === '') return false;
            const paymentType = context.parent.paymentType;
            // Financing confirmation number should be at least 6 characters
            if (paymentType === 'finance') {
              // if (value.trim().length < 6) {
              //   return context.createError({ message: i18next.t('validation.report.financingNumberMinLength') });
              // }
            }
            return true;
          })
          .test('min-length-check', (value, context) => {
            if (!value || value.trim() === '') return false;
            const paymentType = context.parent.paymentType;
            // Check number should be at least 3 characters
            if (paymentType === 'check') {
              if (value.trim().length < 3) {
                return context.createError({ message: i18next.t('validation.report.checkNumberMinLength') });
              }
            }
            return true;
          })
          .test('max-length-check', (value, context) => {
            if (!value || value.trim() === '') return true; 
            const paymentType = context.parent.paymentType;
            const maxLength = paymentType === 'check' ? 30 : 30;
            const trimmedValue = value.trim();
            if (trimmedValue.length > maxLength) {
              return context.createError({ 
                message: paymentType === 'check' 
                  ? i18next.t('validation.report.checkNumberMaxLength') 
                  : i18next.t('validation.report.financingNumberMaxLength')
              });
            }
            return true;
          }),
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
    reason: yup
      .string()
      .trim()
      .nullable()
      .required(i18next.t('validation.report.reasonRequired')),
  };

  return yup.object().shape(shape);
};